<template>
    <svg viewBox="153 309 96 89" fill="none" aria-hidden="true">
        <path
            d="M204.33 397.828V382.258H198.06V397.828H176.37V382.258H160.7C156.83 382.258 153.68 379.088 153.68 375.178V321.478C153.68 317.578 156.83 314.398 160.7 314.398H241.7C245.57 314.398 248.72 317.568 248.72 321.478V375.178C248.72 379.078 245.57 382.258 241.7 382.258H226.03V397.828H204.34H204.33ZM222.05 393.848V378.278H241.7C243.38 378.278 244.74 376.888 244.74 375.178V321.478C244.74 319.768 243.37 318.378 241.7 318.378H160.7C159.02 318.378 157.65 319.768 157.65 321.478V375.178C157.65 376.888 159.02 378.278 160.7 378.278H180.35V393.848H194.09V378.278H208.31V393.848H222.05Z"
            :fill="palette.shadow"
        />
        <path
            d="M224.52 396.328H205.83V380.758H196.56V396.328H177.87V380.758H160.7C157.66 380.758 155.18 378.258 155.18 375.178V321.478C155.18 318.398 157.66 315.898 160.7 315.898H241.7C244.74 315.898 247.22 318.398 247.22 321.478V375.178C247.22 378.258 244.74 380.758 241.7 380.758H224.53V396.328H224.52ZM206.81 395.348H223.55V379.778H241.7C244.21 379.778 246.25 377.718 246.25 375.178V321.478C246.25 318.938 244.21 316.878 241.7 316.878H160.7C158.19 316.878 156.15 318.938 156.15 321.478V375.178C156.15 377.718 158.19 379.778 160.7 379.778H178.85V395.348H195.59V379.778H206.81V395.348Z"
            :fill="palette.accent"
        />
        <path
            d="M204.88 392.411V376.841H197.52V392.411H176.61V376.841H160.25C156.62 376.841 153.66 373.881 153.66 370.251V316.551C153.66 312.921 156.62 309.961 160.25 309.961H242.15C245.78 309.961 248.74 312.921 248.74 316.551V370.251C248.74 373.881 245.78 376.841 242.15 376.841H225.79V392.411H204.88ZM204.66 355.781L201.19 351.621L197.72 355.781H204.65H204.66ZM235.74 345.861V338.071H213.6V345.861H235.74ZM188.8 345.861V338.071H166.66V345.861H188.8Z"
            :fill="palette.shadow"
        />
        <path
            d="M155.16 316.551V370.251C155.16 373.061 157.44 375.341 160.25 375.341H178.11V390.911H196.02V375.341H206.38V390.911H224.29V375.341H242.15C244.96 375.341 247.24 373.061 247.24 370.251V316.551C247.24 313.741 244.96 311.461 242.15 311.461H160.25C157.44 311.461 155.16 313.741 155.16 316.551ZM190.3 347.361H165.16V336.571H190.3V347.361ZM194.53 357.281L201.2 349.281L207.87 357.281H194.53ZM237.24 347.361H212.1V336.571H237.24V347.361Z"
            :fill="palette.accent"
        />
    </svg>
</template>

<script>
import { getKillerPalette } from '../killerPalette.js'

export default {
    name: 'KillerSkullIcon',
    props: {
        color: {
            type: String,
            required: true,
        },
    },
    computed: {
        palette() {
            return getKillerPalette(this.color)
        },
    },
}
</script>
